<div class="w-full h-full bg-pattern flex flex-col items-center justify-center">
  <div @fadeInUp class="card overflow-hidden w-full max-w-md">
    <div class="p-6 pb-0 flex flex-col items-center justify-center">
      <div class="fill-current text-center">
        <img class="w-16" src="assets/img/logo/signet.svg" />
      </div>
    </div>

    <div class="text-center mt-4">
      <h2 class="title m-0">Welcome back</h2>
      <h4 class="body-2 text-secondary m-0">
        Sign in with your credentials below
      </h4>
    </div>

    <div [formGroup]="form" class="p-6 flex flex-col gap-4">
      <div class="flex flex-col">
        <mat-form-field class="flex-1">
          <mat-label>Email</mat-label>
          <input formControlName="email" matInput required type="email" />
          <mat-error *ngIf="form.controls.email.hasError('required')"
            >We need an email address to log you in
          </mat-error>
          <mat-error *ngIf="form.controls.email.hasError('email')"
            >Please provide a valid email address
          </mat-error>
        </mat-form-field>
        <mat-form-field class="flex-1">
          <mat-label>Password</mat-label>
          <input
            [type]="inputType"
            formControlName="password"
            matInput
            required
          />
          <button
            (click)="toggleVisibility()"
            mat-icon-button
            matIconSuffix
            matTooltip="Toggle Visibility"
            type="button"
          >
            <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
            <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
          </button>
          <mat-hint>Click the eye to toggle visibility</mat-hint>
          <mat-error *ngIf="form.controls.password.hasError('required')"
            >We need a password to log you in
          </mat-error>
        </mat-form-field>
      </div>

      <div class="text-right">
        <a [routerLink]="['/forgot-password']" class="caption"
          >Forgot Password?</a
        >
      </div>

      <button (click)="signInWithEmailAndPassword()" color="primary" mat-raised-button type="button">
        Sign in
      </button>

      <div class="flex items-center justify-center">
        <h4 class="body-2 text-secondary m-0">or</h4>
      </div>

      <button
        color="google-plus"
        mat-raised-button
        type="button"
        (click)="signInWithGoogle()"
      >
        <mat-icon [fontIcon]="'fa-google'" class="icon" fontSet="fa"></mat-icon>
        <span>Sign in with Google</span>
      </button>

      <button
        color="facebook"
        mat-raised-button
        type="button"
        (click)="signInWithFacebook()"
      >
        <mat-icon
          [fontIcon]="'fa-facebook'"
          class="icon"
          fontSet="fa"
        ></mat-icon>
        <span>Sign in with Facebook</span>
      </button>

      <button
        color="twitter"
        mat-raised-button
        type="button"
        (click)="signInWithTwitter()"
      >
        <mat-icon
          [fontIcon]="'fa-twitter'"
          class="icon"
          fontSet="fa"
        ></mat-icon>
        <span>Sign in with Twitter / X</span>
      </button>

      <p class="text-secondary text-center">
        Don't have an account?<br />
        <a [routerLink]="['/sign-up']">Click here to create one</a>
      </p>
    </div>
  </div>
</div>
